import { Controller } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "regenerator-runtime/runtime";

class ManagerBase extends Controller {
	constructor () {
		super("managerBase");
	}

	delete (itemList) {
		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const rd = NousCore.api.createRequest({ items: itemList.map(item => { return { guid: item.guid }; }) });
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getByGuid (guid) {
		const rd = NousCore.api.createRequest({item: { guid } });
		const requestedAction = "get-by-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	async getList ({ range, sort } = { range: null, sort: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-list";

		if (range) {
			rd.range = range;
		}

		if (sort) {
			rd.sort = sort;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async getRichList ({ filters, options, range, sort } = { filters: null, options: null, range: null, sort: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-rich-list";

		if (filters) {
			rd.filters = filters;
		}

		if (options) {
			rd.options = options;
		}

		if (range) {
			rd.range = range;
		}

		if (sort) {
			rd.sort = sort;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
	
	async insertMulti (itemList) {
		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const result = [];
	
		if (itemList.length > 0) {
			const insertRequest = NousCore.api.createRequest({ items: itemList.map(item => item.export()) });
			const insertResult = await NousCore.api.send(`${this.remoteClassName}/insert`, insertRequest);

			if (insertResult.isSuccess) {
				switch (insertResult.rc) {
					case 1:
						itemList.forEach((item, index) => {
							item.import(insertResult.items[index]);
							item.clean();
						});
	
						result.insertResult = itemList;

						break;
				}
			}
		}

		return result;
	}

	save (itemList) {
		let actions = new Set();

		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		itemList.forEach(item => {
			actions.add(item.guid === "" ? "insert" : "update");
		});

		if (actions.size > 1) {
			alert("Non posso preosuguire");
			return;
		}
		
		const rd = NousCore.api.createRequest({ item: itemList[0].export() });
		const requestedAction = Array.from(actions)[0];

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						itemList.forEach((item, index) => {
							item.import(data.items[index]);
							item.clean();
						});

						return {
							data: itemList,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async saveMulti (itemList) {
		// let actions = new Set();

		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const insertList = itemList.filter(item => item.guid === "");
		const updateList = itemList.filter(item => item.guid !== "");

		// itemList.forEach(item => {
		// 	actions.add(item.guid === "" ? "insert" : "update");
		// });

		// if (actions.size > 1) {
		// 	alert("Non posso preosuguire");
		// 	return;
		// }
		const result = {
			insertResult: [],
			updateResult: [],
		};
	
		if (insertList.length > 0) {
			const insertRequest = NousCore.api.createRequest({ items: insertList.map(item => item.export()) });
			const insertResult = await NousCore.api.send(`${this.remoteClassName}/insert`, insertRequest);

			if (insertResult.isSuccess) {
				switch (insertResult.rc) {
					case 1:
						insertList.forEach((item, index) => {
							item.import(insertResult.items[index]);
							item.clean();
						});
	
						result.insertResult = insertList;
	
						// return {
						// 	data: itemList,
						// 	requestedAction: "insert",
						// 	status: "ok",
						// };
						// case 99:
						// 	return {
						// 		data,
						// 		requestedAction: "insert",
						// 		status: "ko",
						// 	};
						break;
				}
			}
		}

		// const requestedAction = Array.from(actions)[0];
		if (updateList.length > 0) {
			const updateRequest = NousCore.api.createRequest({ items: updateList.map(item => item.export()) });
			const updateResult = await NousCore.api.send(`${this.remoteClassName}/update`, updateRequest);

			if (updateResult.isSuccess) {
				switch (updateResult.rc) {
					case 1:
						updateList.forEach((item, index) => {
							item.import(updateResult.items[index]);
							item.clean();
						});

						result.updateResult = updateList;
						break;
				}
			}
		}

		return result;
	}

	async upsertMulti (itemList) {
		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const result = [];
	
		if (itemList.length > 0) {
			const matchFields = [
				{ dbName: "content1_guid", apiName: "content1Guid" },
				{ dbName: "content2_guid", apiName: "content2Guid" },
			];
			
			const upsertRequest = NousCore.api.createRequest({ items: itemList.map(item => item.export()), matchFields });
			const upsertResult = await NousCore.api.send(`${this.remoteClassName}/upsert`, upsertRequest);

			if (upsertResult.isSuccess) {
				switch (upsertResult.rc) {
					case 1:
						itemList.forEach((item, index) => {
							item.import(upsertResult.items[index]);
							item.clean();
						});
	
						result.insertResult = itemList;

						break;
				}
			}
		}

		return result;
	}

	upload (target) {
		const requestedAction = "upload2";

		return NousCore.api.uploadFiles(target, `${this.remoteClassName}/${requestedAction}`)
		.then(jsonData => {
			if (jsonData.rc === 9999) {
				return {
					data: [],
					status: "ko",
				};		
			}
			const savedFiles = jsonData.payload.items;
			// const documents = [];
	
			console.log({savedFiles});

			// savedFiles.forEach(savedFile => {
			// 	switch (savedFile.rc) {
			// 		case 1: {
			// 			const fileType = savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1).toLowerCase();
	
			// 			// attemptedSavePath: "../private/documents/60139845-28e8-4ec6-8a7e-f1918923b497/588f4eea-25ce-4943-b10b-35df10483157.jpg"
			// 			// dest_folder: "/var/www/vhosts/livingstone.lineacontinua.net/httpdocs/../private/documents/60139845-28e8-4ec6-8a7e-f1918923b497/"
			// 			// exif: {FileName: "588f4eea-25ce-4943-b10b-35df10483157.jpg", FileDateTime: 1638470556, FileSize: 4633400,…}
			// 			// fileCount: 1
			// 			// filePath: "../private/documents/60139845-28e8-4ec6-8a7e-f1918923b497/588f4eea-25ce-4943-b10b-35df10483157.jpg"
			// 			// fullName: "588f4eea-25ce-4943-b10b-35df10483157.jpg"
			// 			// name: "PXL_20210801_190217272"
			// 			// rc: 1
			// 			// size: 4633400
			// 			// type: "jpg"

			// 			const newDocument = new Document({
			// 				fileSize: savedFile.size,
			// 				fileType: savedFile.type,
			// 				fileURL: savedFile.attemptedSavePath,
			// 				name: savedFile.name,
			// 				revision: 0,
			// 				status: 1,
			// 				thumbnailURL: savedFile.thumbnailURL || "",
			// 			});
	
			// 			documents.push(newDocument);
			// 			break;
			// 		}
			// 		case 95:
			// 			break;
			// 		default:
			// 			alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			// 	}
			// });
	
			return {
				data: savedFiles,
				status: "ok"
			};
		});
	}
}

export default ManagerBase;
